import axiosInstance from "@/common/axiosInstance";
import apiCall from "./apiCall";

export interface Vessel {
    vesselId: string,
    vesselIdentifierType: string,
    vesselName: string,
    imoreg: string,
    type: string | null,
    shipOperatorId: string,
    companyName: string,
};

export interface ShipOwner {
    shipOwnerId: string,
    onBehalfCompany: string,
    vessels: Vessel[],
};

const getShipOwnerData = async () => {
    const URL = '/ShipOwner/GetShipOwnerData';
    return apiCall('get', URL);
};

const getListShipOwner = async (param: any) => {
    const query = `?search=${param.search}&status=${param.status}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/ShipOwner/GetAllShipOwner${query}`;
    return apiCall('get', URL);
};

const getShipOwnerById = async (id: string) => {
    const URL = `/ShipOwner/GetShipOwnerById/${id}`;
    return apiCall('get', URL);
};

const putShipOwner = async (data: any) => {
    const URL = '/ShipOwner/update';
    return apiCall('post', URL, data);
};

const postShipOwner = async (data: any) => {
    const URL = '/ShipOwner/create';

    try {
        const response = await axiosInstance.post<any[]>(URL, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        return response.data;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

const updateStatusShipOperator = async (data: any) => {
    const URL = '/ShipOwner/UpdateStatus';
    return apiCall('post', URL, data);
};

const deleteShipOwner = async (data: any) => {
    const URL = '/ShipOwner/delete';
    return apiCall('post', URL, data);
};

const getGroupedShipOwners = async () => {
    const URL = '/ShipOwner/GetGroupedShipOwners';
    return apiCall('get', URL);
};

const updateOnBehalfCompany = async (data: any) => {
    const URL = '/ShipOwner/UpdateOnBehalfCompany';
    return apiCall('post', URL, data);
}

export {
    deleteShipOwner,
    postShipOwner,
    putShipOwner,
    getShipOwnerData,
    getShipOwnerById,
    getListShipOwner,
    updateStatusShipOperator,
    getGroupedShipOwners,
    updateOnBehalfCompany
}